import React, { FC, RefObject } from 'react';
import { StockDetails } from '../../../store/api';
import { useTranslation } from 'react-i18next';
import { collectionOrder, mapStockDetailsData } from '../../../shared/product/ProductCopyStock';
import { Popup, PopupTheme } from '../../../shared/components/Popup/Popup';

interface LibxStatisticsDropdownProps {
    readonly visible: boolean;
    readonly popoverRef: RefObject<HTMLElement>;
    readonly stockDetails?: StockDetails;
}

export const LibxStatisticsDropdown: FC<LibxStatisticsDropdownProps> = ({ visible, popoverRef, stockDetails }) => {
    const { t } = useTranslation();

    if (!stockDetails) {
        return null;
    }

    const stockDetailsCollections = Object.entries(mapStockDetailsData(stockDetails))
        .map(([spocId, detail]) => ({ spocId, ...detail }))
        .sort(collectionOrder);

    return (
        <Popup
            target={popoverRef}
            visible={visible}
            placement="top-start"
            arrow={true}
            portal={true}
            theme={PopupTheme.CUSTOM}
            displacement={-24}
            popupClassName="connect-popover"
        >
            {stockDetailsCollections.map(stockInfo => {
                const { spocId, spocName, collectionName, usageConditions } = stockInfo;
                const localisedCollectionName = spocId.startsWith('SITE')
                    ? t('components.stockDetails.individualCollection', {
                          spocName,
                          defaultValue: collectionName
                      })
                    : t('components.stockDetails.sharedCollection', {
                          spocName,
                          defaultValue: collectionName
                      });

                return (
                    <section className="bordered-section" key={collectionName}>
                        <span className="title">{localisedCollectionName}</span>
                        <table className="left-aligned-data">
                            <tbody>
                                {Object.keys(usageConditions).map(key => {
                                    const stock = usageConditions[key].overallStock;

                                    return (
                                        <tr key={`${spocId}_${key}`}>
                                            <td>
                                                <span>{stock}</span>
                                            </td>
                                            <td>
                                                <b>
                                                    {t('loanFormat.plain.ebooks', {
                                                        count: stock
                                                    })}
                                                </b>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </section>
                );
            })}
        </Popup>
    );
};
